module.exports = __webpack_public_path__ + "static/media/maps-combined_2020-04-17.3bda9cc5.png";